import { render, staticRenderFns } from "./ArticleColumn.vue?vue&type=template&id=e287ab98&scoped=true&"
import script from "./ArticleColumn.vue?vue&type=script&lang=js&"
export * from "./ArticleColumn.vue?vue&type=script&lang=js&"
import style0 from "./ArticleColumn.vue?vue&type=style&index=0&id=e287ab98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e287ab98",
  null
  
)

export default component.exports